<template>
  <div class="select-server">
    <account-model
      :title="'选择服务'"
      :hasFooter="false"
      @closeModel="closeModel"
    >
      <div
        class="select-content"
        slot="content"
      >
        <div class="top">
          <p class="top-tip">课程时间/内容不合适，可以换课呦！</p>
          <p class="top-tip">去意已决</p>
          <!-- 暂无可调换的课程则置灰处理 -->
          <!-- <el-radio-group v-model="serverType" @change="serverChange">
                       <el-radio :disabled="this.sameStatus != 1" label='0'>
                        <span class="server-icon">
                            <img :src="this.sameStatus == 1 ? require('../../assets/img/tuifei_list_time_icon@2x.png') : require('../../assets/img/tuifei_list_time_icon@2x(1).png')" alt="">调整上课时间/老师
                        </span></el-radio>
                       <el-radio :disabled="this.diffStatus != 1" label='1'>
                        <span class="server-icon">
                            <img :src="this.diffStatus == 1 ? require('../../assets/img/tuifei_list_difficulty_icon@2x.png') : require('../../assets/img/tuifei_list_difficulty_icon@2x(1).png')" alt="">调整课程难度/版本
                        </span></el-radio>
                       <el-radio label='2'>
                        <span class="server-icon">
                            <img :src="goPayIcon" alt="">继续退费
                        </span></el-radio>
                    </el-radio-group> -->
          <el-radio-group v-model="serverType">
            <!-- <el-radio :disabled="this.sameStatus != 1" :label='0'>
                        <span class="server-icon">
                            <img :src="this.sameStatus == 1 ? require('../../assets/img/tuifei_list_time_icon@2x.png') : require('../../assets/img/tuifei_list_time_icon@2x(1).png')" alt="">调整上课时间/老师
                        </span></el-radio>
                       <el-radio :disabled="this.diffStatus != 1" :label='1'>
                        <span class="server-icon">
                            <img :src="this.diffStatus == 1 ? require('../../assets/img/tuifei_list_difficulty_icon@2x.png') : require('../../assets/img/tuifei_list_difficulty_icon@2x(1).png')" alt="">调整课程难度/版本
                        </span></el-radio> -->
            <el-radio :label='2'>
              <span class="server-icon">
                <img
                  :src="goPayIcon"
                  alt=""
                >继续退课
              </span>
            </el-radio>
          </el-radio-group>
          <!-- <div>
                        <span class="uniq-tip">去意已决</span>
                    </div> -->
          <!-- <div>
                        <span v-if="this.sameStatus == 0" class="tip time">{{this.sameTxt}}</span>
                        <span v-if="this.diffStatus == 0" class="tip course">{{this.diffTxt}}</span>
                    </div> -->
        </div>
        <div class="bottom">
          <a
            href="javascript:void(0)"
            @click="closeModel"
            class="btn-cancel"
          >取消</a>
          <button
            class="btn-common"
            :disabled="this.serverType == ''"
            @click="confirm"
            :class="(this.serverType == '') ? 'btn-disable' : 'btn-confirm'"
          >确定</button>
        </div>
      </div>
    </account-model>
  </div>
</template>

<script>
import accountModel from '@/components/sub/accountModel.vue'
export default {
  components: {
    accountModel
  },
  props: ['productType', 'returnParams', 'sameStatus', 'diffStatus', 'sameTxt', 'diffTxt'],
  data () {
    return {
      serverType: '',
      goPayIcon: require('../../assets/img/tuifei_footer_refund_icon@2x(1).png')
    }
  },
  methods: {
    closeModel () {
      this.$emit('closeModel')
      this.serverType = ''
    },
    // serverChange (val) {
    //     this.$set(this.serverType, 0, this.serverType[0])
    //     if (this.serverType.length > 1) {
    //         this.serverType.shift()
    //     }
    // },
    confirm () {
      this.$emit('closeModel')
      if (this.serverType == '0') {
        // 同大纲调课
        window.location.href = 'https://i.xueersi.com/icenter/Web/StudyCenter/MyCourses/index'
      } else if (this.serverType == '1') {
        // 跨大纲调课
        this.$emit('adjustVision')
      } else {
        // 继续退费
        this.$router.push({ name: 'OrderDrop', query: { productType: this.productType, returnParams: this.returnParams } }).catch(() => { })
      }
    }
  }
}
</script>
<style lang="less">
.select-server {
  .account-model .model-content {
    padding: 0 !important;
  }
  .account-model .model-title {
    height: 54px;
    line-height: 54px;
  }
  .account-model .account-model-wrapper {
    width: 608px !important;
    // height: 334px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    border-color: #f13232;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #f13232;
    border-color: #f13232;
  }
  .el-radio__label {
    padding-left: 4px;
  }
  // 单选框样式
  .el-radio {
    display: block;
    margin-bottom: 16px;
    &:first-child {
      margin-top: 19px;
    }
    &:last-child {
      margin-top: 5px;
      margin-bottom: 0;
    }
    .el-radio__label {
      color: #858c96;
      font-size: 12px;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #858c96;
    }
    .el-radio__inner:hover {
      border-color: #f13232;
    }
  }
}
</style>
<style lang="less" scoped>
.select-server {
  .select-content {
    position: relative;
    .top {
      padding: 32px 20px 32px 20px;
      .top-tip {
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 5px;
      }
      .server-icon {
        vertical-align: middle;
        img {
          vertical-align: bottom;
          margin-right: 6px;
          margin-left: 8px;
          width: 20px;
          height: 20px;
          opacity: 0.6;
        }
      }
      .uniq-tip {
        position: absolute;
        top: 152px;
        left: 20px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
      .tip {
        position: absolute;
        display: block;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(240, 119, 60, 1);
      }
      .time {
        top: 78px;
        left: 263px;
      }
      .course {
        top: 115px;
        left: 263px;
      }
    }
    .bottom {
      bottom: 0;
      width: 608px;
      height: 80px;
      background: #fff;
      box-shadow: 0px 1px 0px 0px rgba(220, 220, 220, 1);
      border-radius: 0px 0px 2px 2px;
      border-top: 1px solid #dcdcdc;
      a {
        display: inline-block;
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        border-radius: 2px;
        cursor: pointer;
        padding: 0;
      }
      .btn-common {
        color: #fff;
        font-size: 16px;
        width: 130px;
        height: 40px;
        border-radius: 2px;
        cursor: pointer;
        margin: 0;
        padding: 0;
        outline: none;
        border: 1px solid transparent;
      }
      .btn-disable {
        margin-left: 20px;
        margin-top: 20px;
        width: 130px;
        height: 40px;
        background: #ccc;
      }
      .btn-confirm {
        margin-left: 18px;
        margin-top: 20px;
        background: rgba(241, 50, 50, 1);
      }
      .btn-cancel {
        color: #333;
        margin-left: 162px;
        margin-top: 20px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(222, 222, 222, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/dialog/selectServer.vue